import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="pricing-page">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-medium tracking-tight font-serif hover:text-accent transition-colors">
            Decided
          </Link>
          <Link to="/login">
            <Button variant="ghost" size="sm">
              Log in
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <h1 className="text-3xl md:text-4xl font-medium tracking-tight font-serif text-foreground">
          Pricing
        </h1>
        <p className="mt-4 text-muted-foreground">
          Simple pricing. No tiers. No noise.
        </p>

        {/* Plan */}
        <div className="mt-16 border border-border rounded-lg p-8 max-w-md">
          <h2 className="text-xl font-medium font-serif text-foreground">
            Solo plan
          </h2>
          <p className="mt-4 text-3xl font-medium text-foreground">
            €9 <span className="text-lg font-normal text-muted-foreground">/ month</span>
          </p>
          <p className="mt-1 text-muted-foreground">
            or €90 / year
          </p>

          <div className="mt-8">
            <p className="text-sm text-muted-foreground mb-4">Includes:</p>
            <ul className="space-y-2 text-foreground">
              <li className="flex items-start gap-3">
                <span className="text-foreground/30 select-none">—</span>
                <span>Unlimited decisions</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-foreground/30 select-none">—</span>
                <span>Unlimited follow-ups</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-foreground/30 select-none">—</span>
                <span>Email reminders</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-foreground/30 select-none">—</span>
                <span>Private, secure account</span>
              </li>
            </ul>
          </div>

          <div className="mt-10">
            <Link to="/register">
              <Button size="lg" className="w-full rounded-sm">
                Start using Decided
              </Button>
            </Link>
          </div>

          <p className="mt-6 text-sm text-muted-foreground/70 text-center">
            No long-term commitment. Cancel anytime.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link>
            <Link to="/why" className="hover:text-foreground transition-colors">Why Decided</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
            <Link to="/login" className="hover:text-foreground transition-colors">Login</Link>
          </div>
          <p className="mt-6 text-center text-xs text-muted-foreground/50">
            © {new Date().getFullYear()} Decided
          </p>
        </div>
      </footer>
    </div>
  );
}
